import { useEffect, useState } from 'react';
import { useI18n } from './i18n';

/** Aviso de nueva versión: no se recarga sin permiso del usuario (FR-PWA-02). */
export function UpdatePrompt() {
  const { t } = useI18n();
  const [update, setUpdate] = useState<null | (() => void)>(null);
  useEffect(() => {
    const onUpdate = (e: Event) => setUpdate(() => (e as CustomEvent<() => void>).detail);
    window.addEventListener('habitos:update', onUpdate);
    return () => window.removeEventListener('habitos:update', onUpdate);
  }, []);
  if (!update) return null;
  return (
    <div className="toast-region" role="status" aria-live="polite">
      <div className="toast">
        <span className="spacer">{t('update.available')}</span>
        <button type="button" className="btn" onClick={() => update()}>
          {t('update.reload')}
        </button>
      </div>
    </div>
  );
}
